import React, { useState, useEffect } from "react";
import axios from "axios";
import Social from "./Social";

const InstaFeeds = ({ limit }) => {
  const [feeds, setFeedsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    let cancelled = false;

    async function fetchInstagramPost() {
      setLoading(true);
      setErrored(false);
      try {
        const response = await axios.get(
          `/.netlify/functions/instagram?limit=${limit}`,
          { signal: abortController.signal }
        );

        // Expecting { data: [...] } as before
        const arr = response?.data?.data ?? [];
        if (!cancelled) setFeedsData(Array.isArray(arr) ? arr : []);
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log("Instagram request canceled");
        } else {
          console.error("Instagram fetch error:", err.response?.data || err.message);
          if (!cancelled) {
            setErrored(true);
            setFeedsData([]);
          }
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchInstagramPost();

    return () => {
      cancelled = true;
      abortController.abort();
    };
  }, [limit]);

  // Hide the whole section only AFTER loading has finished and there's no usable data
  if (!loading && (errored || feeds.length === 0)) return null;

  // While loading, render nothing (prevents layout flicker). Remove if you want a skeleton.
  if (loading) return null;

  // Normal render path (keeps your formatting via <Social />)
  return <Social feeds={feeds} />;
};

export default InstaFeeds;
